import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import OpphevMakuleringMiljokontroll from "./OpphevMakuleringMiljokontroll";

import {
  getAllMiljoKontrollHistorikk,
  getMiljokontroll,
  getMiljokontroller,
  putMiljokontrollAvslutt,
} from "../../../../actions/miljokontrollerActions";

export default function OpphevMakuleringMiljokontrollContainer() {
  const dispatch = useDispatch();
  const miljokontroll = useSelector((state) => state.miljokontroll);
  const miljokontrollOversiktFilterForm = useSelector(
    (state) => state.forms.miljokontrollOversiktFilterForm,
  );
  const putMiljokontrollAvsluttAction = useCallback(
    () =>
      dispatch(
        putMiljokontrollAvslutt(
          miljokontroll.id,
          { avslutt: false },
          () => dispatch(getMiljokontroller(miljokontrollOversiktFilterForm)),
          () => dispatch(getMiljokontroll(miljokontroll.id)),
          () => dispatch(getAllMiljoKontrollHistorikk(miljokontroll.id)),
        ),
      ),
    [dispatch, miljokontroll, miljokontrollOversiktFilterForm],
  );

  return (
    <OpphevMakuleringMiljokontroll
      miljokontroll={miljokontroll}
      putMiljokontrollAvslutt={putMiljokontrollAvsluttAction}
    />
  );
}
